/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

import { cloneDeep, uniqueId, camelCase } from 'lodash';

function handleInitialAdjustments({
    questionnaire,
    setFieldValue,
    personData
}) {
    try {
        return handleGroup({
            questionnaire,
            setFieldValue,
            personData
        });

    } catch (e) {
        console.log("HIERARCHY- handleInitialAdjustments error", e);
    }
}

function handleGroup({
    questionnaire,
    setFieldValue,
    personData
}) {
    try {
        let groups = [];
        const legalEntityQuestion = questionnaire.filter((qst) => qst.idQuestion === 2181);
        const baseGroup = cloneDeep(legalEntityQuestion);

        const personLegalEntities = [];

        if (Array.isArray(personData.personRelationships["365"])) {
            personLegalEntities.push(...personData.personRelationships["365"]);
        }

        if (Array.isArray(personData.personRelationships["379"])) {
            personLegalEntities.push(...personData.personRelationships["379"]);
        }

        personLegalEntities.map((legalEntity) => {
            const newGroup = baseGroup.map((qst) => {
                qst = cloneDeep(qst);
                qst.key = `${camelCase(qst.dsQuestion)}_${qst.idQuestion}${uniqueId()}_${uniqueId()}`;
                qst.idQuestionnaireAnswers = null;
                qst.idQuestionnaireAnswersParent = null;
                qst.idQuestionnaireAnswersRoot = null;
                qst.answer = null;
                qst.idAnswerOption = null;

                if (qst.idQuestion === 2181) {
                    qst.dsQuestion = ''
                    qst.answer = JSON.stringify({ id: legalEntity.idPersonTail, value: legalEntity.personTailLastName });
                    qst.answerJson = JSON.stringify({ id: legalEntity.idPersonTail, value: legalEntity.personTailLastName })
                    qst.behaviorObject = {
                        ...qst.behaviorObject,
                        hideSearchIcon: true,
                    }

                    qst.idDomainPersonRelationship = legalEntity.idDomain;
                }

                if (qst.key) setFieldValue(qst.key, String(JSON.parse(qst.answer).value));
                return qst;
            })

            return groups.push(newGroup);
        })

        const legalEntitiesRelationshipOrders = [];

        personLegalEntities.forEach((legalEntity) => {
            const relationshipContent = legalEntity.relationshipContent;
            const legalEntityOrder = relationshipContent?.searchQueryOrder && relationshipContent.searchQueryOrder[0] && relationshipContent.searchQueryOrder[0].order;

            if (legalEntityOrder) {
                legalEntitiesRelationshipOrders.push({ id: legalEntity.idPersonTail, order: legalEntityOrder });
            }
        });

        legalEntitiesRelationshipOrders.sort((a, b) => a.order - b.order);

        let sortedGroups = [];

        for (const legalEntity of legalEntitiesRelationshipOrders) {
            const group = groups.find((group) => group.find((question) => question.idQuestion === 2181 && JSON.parse(question.answer).id === legalEntity.id));

            sortedGroups[legalEntity.order - 1] = group;

            groups = groups.filter((groupFiltered) => groupFiltered !== group);
        }

        sortedGroups.push(...groups);
        sortedGroups = sortedGroups.filter((group) => group);

        return sortedGroups;
    } catch (e) {
        console.log('HIERARCHY - handleGroup error', e)
    }
}

function saveHierarchyOrder(hierarchyGroup) {
    const hierarchyGroupLegalEntities = hierarchyGroup
        ?.map((group) => {
            const legalEntity = group.find((question) => question.idQuestion === 2181)

            return {
                idDomainPersonRelationship: legalEntity.idDomainPersonRelationship,
                idPersonTail: JSON.parse(legalEntity.answer).id,
            }
        })

    return hierarchyGroupLegalEntities;
}

const events = {
    handleInitialAdjustments,
    saveHierarchyOrder
};

export { events };